import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { useBlurAuthToken } from "../../../../blur/useBlurAuth";
import { ActionTimelineFragment } from "../../../../components/ActionTimeline/ActionTimeline.fragment";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../../constants";
import { useAccount } from "../../../../polychain/hooks/useAccount";
import { useSetBlockchainActionErrors } from "../../../hooks/useSetBlockchainActionErrors";
import { useSetBlockchainActionErrorsFragment } from "../../../hooks/useSetBlockchainActionErrors.fragment";
const CollectionSweepQuery = graphql(`
    query CollectionSweepQuery(
      $paymentAsset: ContractIdentifierInput!
      $collectionSlug: String!
      $maxAmountOfItems: Int!
      $maxPricePerItem: BigDecimal!
      $buyer: Address!
      $recipient: Address
      $blurAuthToken: String
    ) {
      sweepCollection(
        buyer: $buyer
        collectionSlug: $collectionSlug
        maxAmountOfItems: $maxAmountOfItems
        maxPricePerItem: $maxPricePerItem
        paymentAsset: $paymentAsset
        recipient: $recipient
        blurAuthToken: $blurAuthToken
      ) {
        actions {
          ...ActionTimeline
        }
        errors {
          ...useSetBlockchainActionErrors
        }
      }
    }
  `, [ActionTimelineFragment, useSetBlockchainActionErrorsFragment]);
export const useCollectionSweepQuery = params => {
  const $ = _c(20);
  const {
    paymentAsset,
    collectionSlug,
    maxAmountOfItems,
    maxPricePerItem,
    recipient,
    pause
  } = params;
  const {
    address
  } = useAccount();
  const blurAuthToken = useBlurAuthToken();
  const t0 = address;
  let t1;
  if ($[0] !== blurAuthToken || $[1] !== collectionSlug || $[2] !== maxAmountOfItems || $[3] !== maxPricePerItem || $[4] !== paymentAsset || $[5] !== recipient || $[6] !== t0) {
    t1 = {
      paymentAsset,
      collectionSlug,
      maxAmountOfItems,
      maxPricePerItem,
      buyer: t0,
      recipient,
      blurAuthToken
    };
    $[0] = blurAuthToken;
    $[1] = collectionSlug;
    $[2] = maxAmountOfItems;
    $[3] = maxPricePerItem;
    $[4] = paymentAsset;
    $[5] = recipient;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = !address || pause;
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = {
      query: CollectionSweepQuery,
      variables: t1,
      pause: t2,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const [t4, refetch] = useQuery(t3);
  const {
    data,
    error,
    fetching
  } = t4;
  let t5;
  if ($[11] !== data?.sweepCollection.actions) {
    t5 = data?.sweepCollection.actions ?? [];
    $[11] = data?.sweepCollection.actions;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const actions = t5;
  useSetBlockchainActionErrors(data?.sweepCollection.errors);
  let t6;
  if ($[13] !== refetch) {
    t6 = () => refetch({
      requestPolicy: "network-only"
    });
    $[13] = refetch;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== actions || $[16] !== error || $[17] !== fetching || $[18] !== t6) {
    t7 = {
      actions,
      error,
      fetching,
      refetch: t6
    };
    $[15] = actions;
    $[16] = error;
    $[17] = fetching;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};